/**
 * Ruoli applicativi assegnabili a un utente.
 *
 * Restano solo quelli che hanno davvero delle pagine. Sono stati tolti:
 * - 'lab': non esisteva nemmeno nell'enum user_role del database, e la rotta
 *   /lab a cui rimandava non e' mai esistita: chi lo avesse avuto sarebbe
 *   rimasto bloccato su un redirect a vuoto.
 * - 'production' e 'customer_user': presenti nell'enum del database ma senza
 *   nessuna voce di menu ne' rotta, quindi un utente con quel ruolo entrava
 *   e non vedeva niente.
 *
 * Nel database l'enum conserva i valori vecchi (toglierli da un enum
 * PostgreSQL e' distruttivo e inutile): semplicemente non sono piu'
 * assegnabili dall'interfaccia.
 */
export const USER_ROLES = [
  'admin',
  'commerciale',
  'amministrazione',
  'lettore',
  'sales',
  'warehouse'
] as const;

export type UserRole = (typeof USER_ROLES)[number];

/**
 * Etichette dei ruoli mostrate in Gestione Utenti.
 *
 * Stanno qui e non dentro la pagina perche' l'elenco era ripetuto quattro
 * volte (due schemi di validazione e due menu a tendina): aggiungere un ruolo
 * significava ricordarsi di toccarli tutti e quattro.
 */
export const ROLE_OPTIONS: ReadonlyArray<{
  value: UserRole;
  label: string;
  description: string;
}> = [
  { value: 'admin', label: 'Amministratore', description: 'Accesso completo' },
  { value: 'commerciale', label: 'Commerciale', description: 'Gestione vendite e clienti' },
  { value: 'amministrazione', label: 'Amministrazione', description: 'Gestione amministrativa e fatturazione' },
  { value: 'lettore', label: 'Lettore', description: 'Solo lettura' },
  { value: 'sales', label: 'Vendite (Esteso)', description: 'Listini avanzati e report' },
  { value: 'warehouse', label: 'Magazzino', description: 'Gestione operativa magazzino' }
];


